/// <reference types="vite-plugin-svgr/client" />

import styled, { StyledComponentPropsWithRef } from 'styled-components'
import ArrowDownSvg from 'assets/icons/arrow-down.svg?react'
import ArrowSvg from 'assets/icons/arrow.svg?react'
import MissionHistoryArrowSvg from 'assets/icons/mission-history-arrow.svg?react'
import VehicleSvg from 'assets/icons/vehicle.svg?react'
import VehicleFilterSvg from 'assets/icons/vehicle-filter.svg?react'
import BellSvg from 'assets/icons/bell.svg?react'
import CalendarSvg from 'assets/icons/calendar.svg?react'
import CancelCrossSvg from 'assets/icons/cancel-cross.svg?react'
import CopySvg from 'assets/icons/copy.svg?react'
import ChecklistReportSvg from 'assets/icons/checklist-report.svg?react'
import ChecklistFilterSvg from 'assets/icons/checklist-filter.svg?react'
import ChecklistSvg from 'assets/icons/checklist.svg?react'
import CheckCircleSvg from 'assets/icons/check-circle.svg?react'
import CheckboxCheckmarkSvg from 'assets/icons/checkbox-checkmark.svg?react'
import CheckmarkSvg from 'assets/icons/checkmark.svg?react'
import CheckmarkBigSvg from 'assets/icons/checkmark-big.svg?react'
import CheckmarkSlotSvg from 'assets/icons/checkmark-slot.svg?react'
import CheckmarkSlotCheckedSvg from 'assets/icons/checkmark-slot-checked.svg?react'
import RadioButtonSvg from 'assets/icons/radiobutton.svg?react'
import ChevronSvg from 'assets/icons/chevron.svg?react'
import ClockSvg from 'assets/icons/clock.svg?react'
import DashSvg from 'assets/icons/dash.svg?react'
import FilterFilterSvg from 'assets/icons/filter-filter.svg?react'
import RoleFilterSvg from 'assets/icons/role-filter.svg?react'
import DiscrepancyReportSvg from 'assets/icons/discrepancy-report-icon.svg?react'
import DotsSvg from 'assets/icons/dots.svg?react'
import DownloadSvg from 'assets/icons/download.svg?react'
import DragCrossSvg from 'assets/icons/drag-cross.svg?react'
import ErrorSvg from 'assets/icons/error.svg?react'
import EmailSvg from 'assets/icons/email.svg?react'
import ExclamationMarkSmallSvg from 'assets/icons/exclamation-mark--small.svg?react'
import ExclamationMarkSvg from 'assets/icons/exclamation-mark.svg?react'
import FilterSvg from 'assets/icons/filter.svg?react'
import FlightNetworkSvg from 'assets/icons/flight-network.svg?react'
import OperationalAreaSvg from 'assets/icons/flight-network/operational-zone.svg?react'
import DeliveryPointSvg from 'assets/icons/flight-network/delivery-point.svg?react'
import StorePointSvg from 'assets/icons/flight-network/store-point.svg?react'
import SafeLandingPointSvg from 'assets/icons/flight-network/safe-landing-point.svg?react'
import LaunchpadPointSvg from 'assets/icons/flight-network/launchpad-point.svg?react'
import PolygonSvg from 'assets/icons/flight-network/polygon.svg?react'
import Ruler from 'assets/icons/flight-network/ruler.svg?react'
import FlytrexLogoFirstLetterSvg from 'assets/icons/flytrex-logo-first-letter.svg?react'
import FlytrexLogoSmallSvg from 'assets/icons/flytrex-logo-small.svg?react'
import FromToSvg from 'assets/icons/from-to.svg?react'
import GearSvg from 'assets/icons/gear.svg?react'
import HammerSvg from 'assets/icons/hammer.svg?react'
import LogoutSvg from 'assets/icons/logout.svg?react'
import MagnifyingGlassSvg from 'assets/icons/magnifying-glass.svg?react'
import ManualSvg from 'assets/icons/manual.svg?react'
import MissionNoteSvg from 'assets/icons/mission-note.svg?react'
import OktaSvg from 'assets/icons/okta.svg?react'
import PersonProfileSvg from 'assets/icons/person-profile.svg?react'
import PlusSvg from 'assets/icons/plus.svg?react'
import RoleSvg from 'assets/icons/role.svg?react'
import TimesMarkSmallSvg from 'assets/icons/times-mark--small.svg?react'
import TrashcanSvg from 'assets/icons/trashcan.svg?react'
import UserInfoSvg from 'assets/icons/user-info.svg?react'
import UserLargeSvg from 'assets/icons/user-large.svg?react'
import UserSvg from 'assets/icons/user.svg?react'
import UserFilterSvg from 'assets/icons/user-filter.svg?react'
import ScrewSvg from 'assets/icons/screw.svg?react'
import WifiSvg from 'assets/icons/wifi.svg?react'
import WrenchSvg from 'assets/icons/wrench.svg?react'
import LaunchpadsSvg from 'assets/icons/launchpads.svg?react'
import LargeDroneSvg from 'assets/icons/large-drone.svg?react'
import VehicleParkedSvg from 'assets/icons/vehicle-parked.svg?react'
import VehicleWarningSvg from 'assets/icons/vehicle-warning.svg?react'
import VehicleErrorSvg from 'assets/icons/vehicle-error.svg?react'
import StatusFilterSvg from 'assets/icons/status-filter.svg?react'
import AboutSvg from 'assets/icons/about.svg?react'
import PencilSvg from 'assets/icons/pencil.svg?react'
import StylusSvg from 'assets/icons/stylus.svg?react'
import HandSvg from 'assets/icons/hand.svg?react'
import RulerSvg from 'assets/icons/ruler.svg?react'
import PolylineSvg from 'assets/icons/polyline.svg?react'
import ExportFNSvg from 'assets/icons/export-fn.svg?react'
import ImportFNSvg from 'assets/icons/import-fn.svg?react'
import ValidateFNSvg from 'assets/icons/validate-fn.svg?react'
import EyeSvg from 'assets/icons/eye.svg?react'
import { theme, type ColorValue } from 'styles/theme'
import type { ComponentProps } from 'react'
import { svgIconHoverClassName, svgNoShrinkClassName } from 'styles/globalCss'

export interface MaybeWithSize {
  size?: number | string
}


export function withSvgIconClassName<Props>(props: Props & MaybeWithClassName & MaybeWithSize) {
  // Order matters!
  return { ...props, className: `${svgIconHoverClassName} ${props.className ?? ''}` }
}

export function withSvgNoShrinkClassName() {
  return { className: svgNoShrinkClassName }
}

type SvgComponentProps = StyledComponentPropsWithRef<typeof TrashcanSvg>
const Trashcan = (props: SvgComponentProps) => <TrashcanSvg {...withSvgIconClassName(props)} />

export type IconType = typeof Trashcan & MaybeWithSize
export interface IconProps extends ComponentProps<IconType> {}

export type SvgType = typeof TrashcanSvg

export const SvgIcons = {
  ArrowSvg,
  MissionHistoryArrowSvg,
  VehicleSvg,
  VehicleFilterSvg,
  FilterFilterSvg,
  ChecklistFilterSvg,
  RadioButtonSvg,
  ArrowDownSvg,
  ClockSvg,
  ChecklistReportSvg,
  CancelCrossSvg,
  CalendarSvg,
  CopySvg,
  DragCrossSvg,
  ErrorSvg,
  EmailSvg,
  FilterSvg,
  DownloadSvg,
  DiscrepancyReportSvg,
  FlightNetworkSvg,
  FromToSvg,
  GearSvg,
  HammerSvg,
  ScrewSvg,
  ChecklistSvg,
  CheckCircleSvg,
  ManualSvg,
  UserSvg,
  UserLargeSvg,
  UserFilterSvg,
  MagnifyingGlassSvg,
  MissionNoteSvg,
  PlusSvg,
  RoleSvg,
  StatusFilterSvg,
  ChevronSvg,
  FlytrexLogoFirstLetterSvg,
  FlytrexLogoSmallSvg,
  PencilSvg,
  TrashcanSvg,
  OktaSvg,
  UserInfoSvg,
  LogoutSvg,
  LaunchpadsSvg,
  LargeDroneSvg,
  VehicleParkedSvg, 
  VehicleWarningSvg,
  VehicleErrorSvg,
  AboutSvg,
  StylusSvg,
  HandSvg,
  RulerSvg,
  PolylineSvg,
  CheckmarkSvg,
  CheckboxCheckmarkSvg,
  CheckmarkBigSvg,
  CheckmarkSlotSvg,
  CheckmarkSlotCheckedSvg,
  RoleFilterSvg,
  OperationalAreaSvg,
  Ruler,
  PolygonSvg,
  DeliveryPointSvg,
  StorePointSvg,
  SafeLandingPointSvg,
  LaunchpadPointSvg,
  ImportFNSvg,
  ExportFNSvg,
  ValidateFNSvg,
  EyeSvg
}

/**
 * To set the color, make sure the source SVG icon file has no `"fill"` or `"stroke"` attributes.__
 *
 * - Use a `color` attribute on the SVG element
 *
 * **OR**
 *
 * - Use a `--color` CSS variable.
 *
 * **OR**
 *
 * - The color will implicitly cascade via CSS using the `currentColor` value.
 * - Use `--size` CSS variable to set the size.
 */
export const TrashcanIcon = styled(Trashcan)
  .attrs((props: IconType)=>({ name: props.name }))<IconType>`
  stroke: none;
`

export const FlytrexLogoFirstLetterIcon = styled((props: IconProps) => (
  <FlytrexLogoFirstLetterSvg {...withSvgIconClassName(props)} />
)).attrs((props: IconType)=>({ name: props.name }))<IconType>`
  stroke: none;
`

// Wrapped in styled in order to allow interpolation in other Linaria components. Won't work otherwise.
export const ChevronIcon = styled((props: IconProps) => <ChevronSvg {...withSvgIconClassName(props)} />)
  .attrs((props: IconType)=>({ name: props.name }))<IconType>``

export const ChevronThinIcon = styled(ChevronIcon)
  .attrs((props: IconType)=>({ name: props.name }))<IconType>`
  transform: rotate(-90deg);
  stroke: none;
`

export const PlusIcon = styled((props: IconProps) => <PlusSvg {...withSvgIconClassName(props)} />)
  .attrs((props: IconType)=>({ name: props.name }))<IconType>`
  stroke: none;
`

export const CheckboxCheckmarkIcon = styled((props: IconProps) => <CheckboxCheckmarkSvg {...withSvgIconClassName(props)} />)
  .attrs((props: IconType)=>({ name: props.name }))<IconType>`
  /* The icon contents aren't a square :/ */
  overflow: visible;
  stroke: none;
`

export const DashIcon = (props: IconProps) => <DashSvg {...withSvgIconClassName(props)} />

export const WifiIcon = styled((props: IconProps) => <WifiSvg {...withSvgIconClassName(props)} />)`
  overflow: visible;
  stroke: none;
`

export const ExclamationMarkIcon = styled((props: IconProps) => (
  <ExclamationMarkSvg {...withSvgIconClassName(props)} />
)).attrs((props: IconType)=>({ name: props.name }))<IconType>`
  fill: ${theme.colors.Red};
  /* TODO: switch to named color */
  stroke: #2d353f;
`

export const PersonProfileIcon = styled((props: IconProps) => (
  <PersonProfileSvg {...withSvgIconClassName(props)} />
)).attrs((props: IconType)=>({ name: props.name }))<IconType>`
  stroke: none;
`

export const WrenchIcon = styled((props: IconProps) => <WrenchSvg {...withSvgIconClassName(props)} />)
  .attrs((props: IconType)=>({ name: props.name }))<IconType>`
  overflow: visible;
  stroke: none;
`

export const BellIcon = styled((props: IconProps) => <BellSvg {...withSvgIconClassName(props)} />)
  .attrs((props: IconType)=>({ name: props.name }))<IconType>`
  overflow: visible;
  stroke: none;
`

export const DotsIcon = styled((props: IconProps) => <DotsSvg {...withSvgIconClassName(props)} />)
  .attrs((props: IconType)=>({ name: props.name }))<IconType>`
  overflow: visible;
`

export const InfoIcon = styled((props: IconProps) => <AboutSvg {...withSvgIconClassName(props)} />)
  .attrs((props: IconType)=>({ name: props.name }))<IconType>`
  overflow: visible;
`

export const MagnifyingGlassIcon = styled((props: IconProps) => (
  <MagnifyingGlassSvg {...withSvgIconClassName(props)} />
)).attrs((props: IconType)=>({ name: props.name }))<IconType>``

const StatusDot = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: var(--size, 1em);
  flex-shrink: 1;
  ::before {
    content: '';
    flex-shrink: 0;
    border-radius: 50%;
    background-color: var(--color, currentColor);
    /* Sizes override 'min-' sizes */
    block-size: var(--size, 0.7em);
    inline-size: var(--size, 0.7em);
  }
`

export const SmallExclamationMarkIcon = styled((props: IconProps) => (
  <ExclamationMarkSmallSvg {...withSvgIconClassName(props)} />
)).attrs((props: IconType)=>({ name: props.name }))<IconType>`
  fill: var(--color, currentColor);
  stroke: ${theme.colors.White};
`

export const SmallTimesMarkIcon = styled((props: IconProps) => (
  <TimesMarkSmallSvg {...withSvgIconClassName(props)} />
)).attrs((props: IconType)=>({ name: props.name }))<IconType>`
  fill: var(--color, currentColor);
  stroke: ${theme.colors.White};
`

const StatusDotText = styled.span`
  flex-shrink: 1;
`

export interface ColorWithText extends WithText {
  color: ColorValue
}

interface StatusDotIconProps extends Omit<StyledComponentPropsWithRef<typeof StatusDot>, 'color'>, ColorWithText {}

export function StatusDotIcon({ color, text, title = text, children, ...props }: StatusDotIconProps) {
  return (
    <StatusDot
      {...({ style: { ...props['style'], '--color': color }, title, ...props } as WithStyle)}
    >
      {children ?? <StatusDotText {...{ children: text }} />}
    </StatusDot>
  )
}
